import React, { useState } from 'react';
import Layout from 'containers/Layout';
import OidcLogin from 'components/OidcLogin';

export const PrivateRoute = ({ component, modules, onAppOrgChange, ...rest }) => {
  const [orgId, setOrgId] = useState(window.selectedOrganizationId);
  const onOrgChange = (orgId) => {
    setOrgId(orgId);
    onAppOrgChange(orgId);
  }
  const { token_type } =
    JSON.parse(localStorage.getItem('pharmaforce')) || {};

  if (token_type) return <Layout modules={modules} onlOrgChange={onOrgChange} />;
  return <OidcLogin />;
};
